<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-20">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">there are code send to your email Please check it to confirm you email</h4>
                                </div>

                                <vs-input  label-placeholder="code" v-model="code" class="w-full mb-8" />
                                <vs-button type="border" @click="Submit" class="px-4 w-full md:w-auto">{{$t('Submit')}}</vs-button>
                                <vs-button  @click="SendCode" class="px-4 w-full md:w-auto ml-12">{{$t('ResenCode')}}</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleUser from "@/store/user/moduleUser.js";
export default {
    data() {
        return {
            value1: '',
            code:'',
            Email:''
        }
    },
    methods:{
       Submit(){
           debugger
           var model ={};
           model.Email = this.Email;
           model.Code = this.code;
debugger
        this.$store.dispatch("UserList/VerifyCodeForConfirmEmail",model).then(res=>{
         var message = '';
         debugger
         if(res.status==200){
           this.$vs.notify({
        color: "success",
        title: "Code Confirmed",
        text: res.data
      });
      if(localStorage.getItem("IncomeCode")!=null&&localStorage.getItem("IncomeCode")!=undefined){
          this.$router.push({name:'page-login', params:{IncomeCode:localStorage.getItem("IncomeCode")} });
      }
      else{
         this.$router.push('/pages/login'); 
      }
            // this.$router.push('/pages/login');

         }
         else{
               this.$vs.notify({
        color: "danger",
        title: "Code Confirmed",
        text: res.data
      });
         }
        });
       },
        SendCode(){
           debugger
        this.$store.dispatch("UserList/SendCode", this.Email).then(res=>{
         var message = '';
         if(res.data.message==undefined){
           message = res[0].data.message
         }
         else{
             message =res.data.message
         }
         this.$vs.notify({
        color: "warning",
        title: "Send Code",
        text: message.Value
      });
      debugger
      }).catch(err => {
        console.error(err);
      });
       },
    },
     created() {
    if (!moduleUser.isRegistered) {
      this.$store.registerModule("UserList", moduleUser);
      moduleUser.isRegistered = true;

    }
    this.Email = this.$route.params.Email;

  },
  mounted() {
    this.isMounted = true;
  }
}
</script>
